import React, { useEffect, useState, useRef,useContext } from 'react';
import { ArrowRightOutlined, DownloadOutlined, PaperClipOutlined, LoadingOutlined, DownOutlined, InfoCircleOutlined, CheckCircleOutlined, ShareAltOutlined, CarOutlined, ShoppingCartOutlined, PrinterOutlined, InfoOutlined, FlagOutlined, ArrowLeftOutlined, EditOutlined, FilterOutlined } from '@ant-design/icons';
import { Dropdown, Row, Col, Button, message, Card, Modal, Tabs, Select, Checkbox, Radio, Form, Tooltip, Image, Input, Upload, Typography, Menu, InputNumber, Empty, Switch } from 'antd';
import TwoDImagesContext from '../../ContextFiles/TwoDImagesContext';
import "./TwoDImages.scss";

const VIDEO_MODE_OPTIONS = [
    { label: 'All', value: 'all' },
    { label: 'Custom',    value: 'custom' },
    { label: 'Influencer', value: 'influencer' },
    { label: '360° Spin', value: 'panorama_360' },
];

const ResolutionRadioButtons = ({ tabName }) => {
    const {
        resolution,
        setResolution,
        onChangeResolution,
        onChangeTabResolution,
        getTabResolution,
        formState,
        setFormState,
    } = useContext(TwoDImagesContext);

    // Use tab-specific resolution if tabName is provided, otherwise use global resolution
    const currentResolution = tabName ? getTabResolution(tabName) : resolution;

    const handleResolutionChange = (e) => {
        const newResolution = e.target.value;
        if (tabName) {
            onChangeTabResolution(tabName, newResolution);
        } else {
            onChangeResolution(e);
        }
    };

    const handleVideoModeChange = (value) => {
        setFormState((prev) => ({ ...prev, videoMode: value === 'all' ? '' : value }));
    };

    return (
        <div className="resolutions-tab manrope f-14 black-55" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span className="resolutions-tab-span">
                Show:
            </span>
            <Radio.Group onChange={handleResolutionChange} value={currentResolution}>
                <Radio value='all'>
                    All
                </Radio>
                <Radio value='1k'>
                    1K
                </Radio>
                <Radio value='2k'>
                    2K
                </Radio>
                <Radio value='4k'>
                    4K
                </Radio>
                <Radio value='custom'>
                    Custom
                </Radio>
            </Radio.Group>
            {tabName === 'ai_video' && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <div style={{ width: 1, height: 14, background: '#d9d9d9', margin: '0 4px' }} />
                    <span className="resolutions-tab-span">Video Type:</span>
                    <Select
                        size="small"
                        value={formState?.videoMode || 'all'}
                        onChange={handleVideoModeChange}
                        options={VIDEO_MODE_OPTIONS}
                        style={{ width: 108 }}
                        variant="borderless"
                        className="video-mode-select manrope f-14 black-55"
                        popupMatchSelectWidth={false}
                    />
                </div>
            )}
        </div>
    );
};

export default ResolutionRadioButtons;
